/**
 * Name: Get song url saga
 * Author: @Gaurav
 * Date: 19-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller(`/songs/${payload}`, 'GET');
};

export default function* watchRequest() {
  yield takeLatest('GET_SONG_URL', function* performAction(action) {
    yield put({ type: 'GET_SONG_URL_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'GET_SONG_URL_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'GET_SONG_URL_FAILED', payload: error });
    }
  });
}
